<template>
  <div class="site" v-loading.fullscreen.lock="loading">
    <el-backtop :target="header" ref="scrollTarget">
      <i class="fas fa-chevron-up"></i>
    </el-backtop>
    <div class="grid header h90" v-lazy:background-image.container="'/static/img/eins-living-room-header.jpg'" style="background-position: center;">
      <div class="grid nav">
        <div class="logo"><img src="/static/img/logo.png"></div>
        <div class="grid actions hidden-xs">
          <a href="#apartments" aria-label="Die Appartements im Residence Paulserhof" v-scroll-to="{el: '#apartments', duration: 500, easing: 'ease-in'}" v-if="lang === 'de' || lang === 'en'">Appartements</a>
          <a href="#apartments" aria-label="Die Appartements im Residence Paulserhof" v-scroll-to="{el: '#apartments', duration: 500, easing: 'ease-in'}" v-if="lang === 'it'">Appartementi</a>
          <a href="#freizeit" aria-label="Freizeit und Sport in Eppan und Umgebung" v-scroll-to="{el: '#freizeit', duration: 500, easing: 'ease-in'}" v-if="lang === 'de'">Freizeit & Sport</a>
          <a href="#freizeit" aria-label="Freizeit und Sport in Eppan und Umgebung" v-scroll-to="{el: '#freizeit', duration: 500, easing: 'ease-in'}" v-if="lang === 'it'">Tempo libero & Sport</a>
          <a href="#freizeit" aria-label="Freizeit und Sport in Eppan und Umgebung" v-scroll-to="{el: '#freizeit', duration: 500, easing: 'ease-in'}" v-if="lang === 'en'">Surroundings & Sport</a>
          <a href="#kulinarik" aria-label="Gaumenfreuden im Restaurant Paulserhof" v-scroll-to="{el: '#kulinarik', duration: 500, easing: 'ease-in'}" v-if="lang === 'de'">Kulinarik</a>
          <a href="#kulinarik" aria-label="Gaumenfreuden im Restaurant Paulserhof" v-scroll-to="{el: '#kulinarik', duration: 500, easing: 'ease-in'}" v-if="lang === 'it'">Culinaria</a>
          <a href="#kulinarik" aria-label="Gaumenfreuden im Restaurant Paulserhof" v-scroll-to="{el: '#kulinarik', duration: 500, easing: 'ease-in'}" v-if="lang === 'en'">Culinary</a>
          <a href="#contact" aria-label="Kontaktieren Sie uns" v-scroll-to="{el: '#contact', duration: 500, easing: 'ease-in'}" v-if="lang === 'de'">Kontakt</a>
          <a href="#contact" aria-label="Kontaktieren Sie uns" v-scroll-to="{el: '#contact', duration: 500, easing: 'ease-in'}" v-if="lang === 'it'">Contatti</a>
          <a href="#contact" aria-label="Kontaktieren Sie uns" v-scroll-to="{el: '#contact', duration: 500, easing: 'ease-in'}" v-if="lang === 'en'">Contact</a>
          <a href="#" aria-label="Jetzt anfragen" class="request" @click="drawer.open = true, drawer.direction = 'rtl', selectedroom = rooms.eins" v-if="lang === 'de'">Jetzt anfragen</a>
          <a href="#" aria-label="Jetzt anfragen" class="request" @click="drawer.open = true, drawer.direction = 'rtl', selectedroom = rooms.eins" v-if="lang === 'it'">Richiedi adesso</a>
          <a href="#" aria-label="Jetzt anfragen" class="request" @click="drawer.open = true, drawer.direction = 'rtl', selectedroom = rooms.eins" v-if="lang === 'en'">Request now</a>
          <div class="grid lang">
            <router-link to="/" aria-label="Deutsche Version">DE</router-link>
            <span> / </span>
            <router-link to="/it" aria-label="Italiano">IT</router-link>
            <span> / </span>
            <router-link to="/en" aria-label="English">EN</router-link>
          </div>
        </div>
        <div class="grid lang visible-xs">
          <router-link to="/" aria-label="Deutsche Version">DE</router-link>
          <span> / </span>
          <router-link to="/it" aria-label="Italiano">IT</router-link>
          <span> / </span>
          <router-link to="/en" aria-label="English">EN</router-link>
        </div>
        <div class="grid social">
          <a href="https://www.facebook.com/residencepaulserhof/" target="new" aria-label="Facebook Link"><i class="fab fa-facebook-square"></i></a>
          <a href="https://www.instagram.com/residence_paulserhof" target="new" aria-label="Instagram Link"><i class="fab fa-instagram"></i></a>
        </div>
      </div>
      <div class="grid quickoffer">
        <div class="grid one" v-for="room in rooms">
          <div class="grid desc">
            <div class="grid img" v-lazy:background-image.container="room.pics[0]"></div>
            <div class="grid content">
              <span class="title">{{room.name}}</span>
              <div class="grid stars">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
              </div>
              <div class="grid price">
                <span>{{room.price}}</span>
              </div>
            </div>
          </div>
          <!-- <div class="cta"> -->
            <!-- <a class="cta" @click="show('request', rooms.eins)"><i class="fas fa-angle-right"></i></a> -->
            <a aria-label="Appartement ansehen" class="cta" @click="modal = true, selectedroom = room"><i class="fas fa-angle-right"></i></a>
          <!-- </div> -->
        </div>
        <!-- <div class="grid one">
          <div class="grid desc">
            <div class="grid img"></div>
            <div class="grid content">
              <span class="title">Zwei</span>
              <div class="grid stars">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
              </div>
              <div class="grid price">
                <span>€ 120,00</span>
              </div>
            </div>
          </div>
          <a class="cta" @click="modal = true, selectedroom = rooms.zwei"><i class="fas fa-angle-right"></i></a>
        </div> -->
      </div>
    </div> <!-- header -->
    <div class="grid welcome">
      <h1>{{welcome.title}}</h1>
      <div class="container grid intro" v-html="welcome.intro">
        <!-- <span v-html="content.intro.one"></span>
        <span v-html="content.intro.two"></span> -->
      </div>
    </div>

    <div class="grid appartements" id="apartments">

      <div class="grid eins" id="eins">
        <div class="grid container">
          <div class="grid text">
            <h1>{{rooms.eins.name}}</h1>
            <span v-html="rooms.eins.desc"></span>
          </div>
          <div class="grid action">
            <div class="grid box">
              <div class="grid img" v-lazy:background-image.container="rooms.eins.pics[0]" @click="openGallery(0, rooms.eins.pics)"></div>
              <div class="grid cta">
                <div class="grid price">
                  <!-- <span><small>Vorsaison</small></span> -->
                  <span>{{rooms.eins.price}}</span>
                  <!-- <span>{{rooms.eins.pricemainseason}}</span> -->
                </div>
                <div class="grid stars">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </div>
                <button aria-label="Jetzt anfragen" type="button" @click="drawer.open = true, drawer.direction = 'rtl', selectedroom = rooms.eins" class="btn dark hidden-xs" v-if="lang === 'de'">Jetzt anfragen</button>
                  <button aria-label="Jetzt anfragen" type="button" @click="drawer.open = true, drawer.direction = 'rtl', selectedroom = rooms.eins" class="btn dark hidden-xs" v-if="lang === 'it'">Richiedi adesso</button>
                  <button aria-label="Jetzt anfragen" type="button" @click="drawer.open = true, drawer.direction = 'rtl', selectedroom = rooms.eins" class="btn dark hidden-xs" v-if="lang === 'en'">Request now</button>
                <button aria-label="Jetzt anfragen" type="button" @click="drawer.open = true, drawer.direction = 'btt', selectedroom = rooms.eins" class="btn green visible-xs"><i class="fas fa-angle-right"></i></button>
                <!-- <a class="cta" @click="drawer.open = true"><i class="fas fa-angle-right"></i></a> -->
              </div>
              <div class="grid features">
                <i class="fas fa-tv"></i>
                <i class="fas fa-coffee"></i>
                <i class="fas fa-utensils"></i>
                <i class="fas fa-temperature-low"></i>
                <i class="fas fa-parking"></i>
                <i class="fas fa-shower"></i>
                <i class="fas fa-wifi"></i>
              </div>
            </div>
          </div>
        </div>

      </div> <!-- eins -->

      <div class=" carousel container">

          <!-- <div class="item" v-for="item in rooms.eins.pics" style="background-size: cover; background-position: center;" v-lazy:background-image.container="item"></div> -->

          <carousel :perPage="3" :loop="true" :spacePadding="0" :navigationEnabled="true" :paginationEnabled="false" navigationNextLabel="<i class='fas fa-chevron-right'></i>" navigationPrevLabel="<i class='fas fa-chevron-left'></i>">
            <slide class="slide" :key="index" v-for="(item, index) in rooms.eins.pics.slice(1)">
              <div class="item">
                <div @click="openGallery(index + 1, rooms.eins.pics)" class="img" style="background-size: cover; background-position: center;" v-lazy:background-image.container="item"></div>
              </div>
            </slide>
          </carousel>

        </div>

        <div class="grid wrapper"></div>

        <div class="grid zwei" id="zwei">
          <div class="grid container">
            <div class="grid action">
              <div class="grid box">
                <div class="grid img" v-lazy:background-image.container="rooms.zwei.pics[0]" @click="openGallery(0, rooms.zwei.pics)"></div>
                <div class="grid cta">
                  <div class="grid price">
                    <span>{{rooms.zwei.price}}</span>
                  </div>
                  <div class="grid stars">
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                  </div>
                  <button aria-label="Jetzt anfragen" type="button" @click="drawer.open = true, drawer.direction = 'rtl', selectedroom = rooms.zwei" class="btn dark hidden-xs" v-if="lang === 'de'">Jetzt anfragen</button>
                  <button aria-label="Jetzt anfragen" type="button" @click="drawer.open = true, drawer.direction = 'rtl', selectedroom = rooms.zwei" class="btn dark hidden-xs" v-if="lang === 'it'">Richiedi adesso</button>
                  <button aria-label="Jetzt anfragen" type="button" @click="drawer.open = true, drawer.direction = 'rtl', selectedroom = rooms.zwei" class="btn dark hidden-xs" v-if="lang === 'en'">Request now</button>
                  <button aria-label="Jetzt anfragen" type="button" @click="drawer.open = true, drawer.direction = 'btt', selectedroom = rooms.zwei" class="btn green visible-xs"><i class="fas fa-angle-right"></i></button>
                </div>
                <div class="grid features">
                  <i class="fas fa-tv"></i>
                  <i class="fas fa-coffee"></i>
                  <i class="fas fa-utensils"></i>
                  <i class="fas fa-temperature-low"></i>
                  <i class="fas fa-parking"></i>
                  <i class="fas fa-shower"></i>
                  <i class="fas fa-wifi"></i>
                </div>
              </div>
            </div>
            <div class="grid text">
              <h1>{{rooms.zwei.name}}</h1>
              <span v-html="rooms.zwei.desc"></span>
            </div>
          </div>

        </div> <!-- zwei -->


          <div class=" carousel2 container">

            <carousel :perPage="3" :loop="true" :spacePadding="0" :navigationEnabled="true" :paginationEnabled="false" navigationNextLabel="<i class='fas fa-chevron-right'></i>" navigationPrevLabel="<i class='fas fa-chevron-left'></i>">
            <slide class="slide" :key="index" v-for="(item, index) in rooms.zwei.pics.slice(1)">
              <div class="item">
                <div @click="openGallery(index + 1, rooms.zwei.pics)" class="img" style="background-size: cover; background-position: center;" v-lazy:background-image.container="item"></div>
              </div>
            </slide>
          </carousel>

            <!-- <div class="item" v-for="item in rooms.zwei.pics" style="background-size: cover; background-position: center;" v-lazy:background-image.container="item"></div> -->

<!--             <carousel2 :dots="false" :loop="false" :margin="24" :nav="true" :navText="['<i ></i>', 'd']">
              <template slot="prev"><span class="prev">prev</span></template>

                <div class="item" :key="index" v-for="(item, index) in rooms.zwei.pics" style="background-size: cover; background-position: center;" v-lazy:background-image.container="item"></div>

              <template slot="next"><span class="next">next</span></template>
            </carousel2> -->

<!--             <slick
              ref="slick"
              :options="slickOptions">
              <div class="item" :key="index" v-for="(item, index) in rooms.zwei.pics" style="background-size: cover; background-position: center;" v-lazy:background-image.container="item"></div>
            </slick> -->

          </div>

        </div>

      
<!--         <el-carousel class="carousel" :interval="4000" type="card" indicator-position="none" :autoplay="false" height="320px">
          <el-carousel-item v-for="item in slides.eins" style="background-size: cover; background-position: center; transform: scale(1)!important;" v-lazy:background-image.container="item">
          </el-carousel-item>
        </el-carousel> -->

      <!-- <div class="grid carousel2">carousel</div> -->

      <div class="grid freizeit h80" id="freizeit">
        
        <div class="grid intro">
          <h1>{{freetime.title}}</h1>
          <h2>{{freetime.intro}}</h2>
        </div>

        <div class="grid header" style="background-size: cover; background-position: center;" v-lazy:background-image.container='freetime.mainimg'>
          <!-- <h1 class="desc">Pragser Wildsee</h1> -->
        </div>

        <div class="grid content">
          
          <div class="grid box" v-for="sport in freetime.sports">
            <a :href="sport.value.link" target="new" aria-label="sport.value.title"><div class="grid header" style="background-size: cover; background-position: center;" v-lazy:background-image.container='sport.value.img'></div></a>
            <h2>{{sport.value.title}}</h2>
            <span v-html="sport.value.desc"></span>
          </div>

        </div>

      </div> <!-- freizeit -->

      <div class="grid kulinarik" id="kulinarik">
        
        <div class="grid intro">
          <h1>{{kulinarik.title}}</h1>
          <h2>{{kulinarik.intro}}</h2>
        </div>

        <div class="grid header" style="background-size: cover; background-position: center;" v-lazy:background-image.container='kulinarik.mainimg'></div>

        <div class="grid content">
          
          <div class="grid box" v-for="dish in kulinarik.dishes">
            <div class="grid header" style="background-size: cover; background-position: center;" v-lazy:background-image.container='dish.img'></div>
          </div>

        </div>

        <div class="grid desc" v-html="kulinarik.desc"></div>

      </div> <!-- kulinarik -->

      <div class="grid lastcall">
        <div class="grid one">
          <div class="grid desc">
            <div class="grid img" v-lazy:background-image.container="rooms.eins.pics[0]"></div>
            <div class="grid content">
              <span class="title">Eins</span>
              <div class="grid stars">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
              </div>
              <div class="grid price">
                <span>{{rooms.eins.price}}</span>
              </div>
            </div>
          </div>
          <!-- <a class="cta" href="#"><i class="fas fa-angle-right"></i></a> -->
          <button aria-label="Jetzt anfragen" type="button" @click="drawer.open = true, drawer.direction = 'rtl', selectedroom = rooms.eins" class="btn green cta"><i class="fas fa-angle-right"></i></button>
        </div>
        <div class="grid one">
          <div class="grid desc">
            <div class="grid img" v-lazy:background-image.container="rooms.zwei.pics[0]"></div>
            <div class="grid content">
              <span class="title">Zwei</span>
              <div class="grid stars">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
              </div>
              <div class="grid price">
                <!-- <span>€ 120,00</span> -->
                <span>{{rooms.zwei.price}}</span>
              </div>
            </div>
          </div>
          <!-- <a class="cta" href="#"><i class="fas fa-angle-right"></i></a> -->
          <button aria-label="Jetzt anfragen" type="button" @click="drawer.open = true, drawer.direction = 'rtl', selectedroom = rooms.zwei" class="btn green cta"><i class="fas fa-angle-right"></i></button>
        </div>
      </div>

    <footer class="grid footer" id="contact">
      <div class="grid top">
        <div class="grid content">
          <div class="grid address">
            <address>Residence Paulserhof</address>
            <address>Unterrainer Strasse 21</address>
            <address>I-39050 St. Pauls/S. Paolo (BZ)</address>
            <address>BZ - Italy</address>
            <div class="spacer xs"></div>
            <span>Mwst.Nr.: IT00485670210</span>
            <span>Tel: +39-0471-662422</span>
            <span>Fax: +39-0471-673665</span>
            <div class="spacer xs"></div>
            <span>E-mail: info@paulserhof.com</span>
            <div class="grid social">
              <a href="https://www.facebook.com/residencepaulserhof/" target="new" aria-label="Facebook Link"><i class="fab fa-facebook-square"></i></a>
              <a href="https://www.instagram.com/residence_paulserhof" target="new" aria-label="Instagram Link"><i class="fab fa-instagram"></i></a>
            </div>
          </div>
          <div class="grid logo">
            
          </div>
          <div class="grid menu">
            <a href="#apartments" aria-label="Die Appartements im Residence Paulserhof" v-scroll-to="{el: '#apartments', duration: 500, easing: 'ease-in'}" v-if="lang === 'de' || lang === 'en'">Appartements</a>
            <a href="#apartments" aria-label="Die Appartements im Residence Paulserhof" v-scroll-to="{el: '#apartments', duration: 500, easing: 'ease-in'}" v-if="lang === 'it'">Appartementi</a>
            <div class="spacer xs"></div>
            <a href="#eins" aria-label="Die Appartements im Residence Paulserhof" v-scroll-to="{el: '#eins', duration: 500, easing: 'ease-in'}">Eins</a>
            <a href="#zwei" aria-label="Die Appartements im Residence Paulserhof" v-scroll-to="{el: '#zwei', duration: 500, easing: 'ease-in'}">Zwei</a>
            <div class="spacer xs"></div>
            <a href="#freizeit" aria-label="Freizeit und Sport in Eppan und Umgebung" v-scroll-to="{el: '#freizeit', duration: 500, easing: 'ease-in'}" v-if="lang === 'de'">Freizeit & Sport</a>
            <a href="#freizeit" aria-label="Freizeit und Sport in Eppan und Umgebung" v-scroll-to="{el: '#freizeit', duration: 500, easing: 'ease-in'}" v-if="lang === 'it'">Tempo libero & Sport</a>
            <a href="#freizeit" aria-label="Freizeit und Sport in Eppan und Umgebung" v-scroll-to="{el: '#freizeit', duration: 500, easing: 'ease-in'}" v-if="lang === 'en'">Surroundings & Sport</a>
            <a href="#kulinarik" aria-label="Gaumenfreuden im Restaurant Paulserhof" v-scroll-to="{el: '#kulinarik', duration: 500, easing: 'ease-in'}" v-if="lang === 'de'">Kulinarik</a>
            <a href="#kulinarik" aria-label="Gaumenfreuden im Restaurant Paulserhof" v-scroll-to="{el: '#kulinarik', duration: 500, easing: 'ease-in'}" v-if="lang === 'it'">Culinaria</a>
            <a href="#kulinarik" aria-label="Gaumenfreuden im Restaurant Paulserhof" v-scroll-to="{el: '#kulinarik', duration: 500, easing: 'ease-in'}" v-if="lang === 'en'">Culinary</a>
            <div class="spacer xs"></div>
            <span>St. Pauls / Eppan</span>
            <div class="spacer xs"></div>
            <a href="http://paulserhof.com/" aria-label="Gaumenfreuden im Restaurant Paulserhof" target="new">Restaurant Paulserhof</a>
          </div>
        </div>
      </div>
      <div class="grid wrapper"></div>
      <div class="grid bottom">
        <span>copyright Switch</span>
        <span>
          <!-- <a href="https://www.iubenda.com/privacy-policy/18600132" target="new" aria-label="Privacy Policy">privacy</a> / <a href="https://www.iubenda.com/privacy-policy/18600132/cookie-policy" target="new" aria-label="Cookie Policy">cookie policy</a> / <a @click="show('impressum')">Impressum</a> -->
          <a @click="show('impressum')">Privacy / Impressum</a>
        </span>
      </div>
    </footer>


    <el-dialog
      :visible.sync="modal"
      :fullscreen="true"
      :lock-scroll="true">
      
      <div class="grid requestform">
        <div class="grid gallery " >
          <el-carousel trigger="click" :interval="5000" :autoplay="false">
            <el-carousel-item v-for="(item, index) in selectedroom.pics" :key="index" style="z-index: 1; background-size: cover; background-position: center;" v-lazy:background-image.container='item'>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class=" content">

          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item class="link"><a @click="modal = false">Home</a></el-breadcrumb-item>
            <el-breadcrumb-item>Appartements</el-breadcrumb-item>
            <el-breadcrumb-item class="active">{{selectedroom.name}}</el-breadcrumb-item>
          </el-breadcrumb>

          <div class="grid desc">
            <h1>{{selectedroom.name}}</h1>
            <div class="grid stars">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
              </div>
            <div class="grid">
              <span><i class="fas fa-user-friends"></i> 2 - 4</span>
              <span><i class="fas fa-parking"></i> reservierter Parkplatz</span>
            </div>
            <div class="grid text">
              <span v-html="selectedroom.desc"></span>
            </div>
            <!-- <div class="grid price">
              <h3>{{selectedroom.price}}</h3>
            </div> -->
          </div>

          <div class=" cta">
            <button aria-label="Unverbindlich Anfragen" type="button" class="btn green" @click="drawer.open = true" v-if="lang === 'de'">Unverbindlich Anfragen</button>
            <button aria-label="Unverbindlich Anfragen" type="button" class="btn green" @click="drawer.open = true" v-if="lang === 'it'">Richiesta senza impegno</button>
            <button aria-label="Unverbindlich Anfragen" type="button" class="btn green" @click="drawer.open = true" v-if="lang === 'en'">Request a not binding quote</button>
          </div>

        </div>
<!--         <div class="grid actions">
          <i @click="hide('request')" class="fas fa-window-close"></i>
          <i class="fas fa-receipt"></i>
        </div> -->
      </div>

    </el-dialog>

    <el-dialog
      :visible.sync="requestthx"
      :lock-scroll="true"
      custom-class="receipt">

      <div class="grid requestthx">
        <div class="grid img" style="background-size: cover; background-position: center;" v-lazy:background-image.container='selectedroom.mainimg'></div>
        <div class="grid content">
          <div>
            <h3 v-if="lang === 'de'">Vielen Dank für Ihre Anfrage {{request.name}}</h3>
            <p v-if="lang === 'de'">Wir melden uns in Kürze mit einem persönlichem Angebot.</p>

            <h3 v-if="lang === 'it'">Grazie per la Sua richiesta {{request.name}}</h3>
            <p v-if="lang === 'it'">Le invieremo una proposta personalizzata al piu presto possibile.</p>

            <h3 v-if="lang === 'en'">Thank you very much for your request {{request.name}}</h3>
            <p v-if="lang === 'en'">We´ll send you a personalized offer as soon as possible.</p>

          </div>
          <div class="grid recap">
            <h4>{{selectedroom.name}}</h4>
            <span>{{request.name}}</span>
            <span>{{request.email}}</span>
            <span>{{request.arrival}} - {{request.departure}}</span>
          </div>
          <button aria-label="Fenster schliessen" type="button" class="btn green block" @click="requestthx = false" v-if="lang === 'de'">schliessen</button>
          <button aria-label="Fenster schliessen" type="button" class="btn green block" @click="requestthx = false" v-if="lang === 'it'">chiudi</button>
          <button aria-label="Fenster schliessen" type="button" class="btn green block" @click="requestthx = false" v-if="lang === 'en'">close</button>
        </div>
      </div>

    </el-dialog>

    <el-drawer
      v-on:keydown.esc="drawer.open = false"
      size="auto"
      :ref="drawer"
      :direction="drawer.direction"
      :destroy-on-close="true"
      :visible.sync="drawer.open">
      
      <div class="grid quickrequest">
        <div class="grid room">
          <!-- <i class="fas fa-check-circle"></i> -->
          <div class="grid img" style="background-size: cover; background-position: center;" v-lazy:background-image.container='selectedroom.pics[0]'></div>
            <h3>{{selectedroom.name}}</h3>
        </div>
        <div class="grid form">

          <el-form :rules="rules" :model="request" status-icon ref="requestForm">

          <el-form-item :label="formlang.date" prop="date">
            <el-date-picker
              v-model="request.date"
              type="daterange"
              format="dd.MM.yyyy"
              range-separator=" - "
              :start-placeholder="formlang.start"
              :end-placeholder="formlang.end" style="width: 100%;">
            </el-date-picker>
          </el-form-item>

          <div class="spacer sm"></div>

          <div class="grid data">

          <el-form-item :label="formlang.name">
            <el-input :placeholder="formlang.name" type="text" v-model="request.name"></el-input>
          </el-form-item>

          <el-form-item :label="formlang.email" prop="email">
            <el-input :placeholder="formlang.email" type="email" v-model="request.email"></el-input>
          </el-form-item>

          <el-form-item :label="formlang.phone">
            <el-input :placeholder="formlang.phone" type="tel" v-model="request.phone"></el-input>
          </el-form-item>

          </div>

          <el-form-item :label="formlang.message">
            <el-input
              type="textarea"
              :rows="8"
              placeholder=""
              v-model="request.message">
            </el-input>
          </el-form-item>

          <div class="spacer sm"></div>

          <el-form-item>
            <button aria-label="Anfrage senden" type="button" class="btn green" @click="sendrequest('requestForm')" v-if="!sentok || senderror">{{formlang.send}}</button>
          </el-form-item>

          <h3 v-if="sentok && !senderror">Vielen Dank für Ihre Anfrage {{request.name}}, wir melden uns in Kürze mit einem persönlichem Angebot.</h3>
          <h3 v-if="senderror && !sentok">Leider ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.</h3>

          <button aria-label="Schliessen" type="button" class="btn green" v-on:click="drawer = false" v-if="sentok && !senderror">Hier gehts weiter <i class="fas fa-angle-right"></i></button>


          </el-form>

        </div>
      </div>

    </el-drawer>

    <modal name="impressum" :scrollable="true" :pivotX="0.5" :pivotY="0.5" height="auto">
      <div class="grid impressum">
        <button type="button" class="btn green close" @click="hide('impressum')"><i class="fas fa-times"></i></button>
      
        <h1>Eigentümer</h1>
        <span><strong>Residence Paulserhof</strong></span>
        <span>Unterrainer Strasse 21</span>
        <span>I-39050 St. Pauls/S. Paolo (BZ)</span>
        <span>BZ - Italy</span>
        <span>Mwst.Nr.: IT00485670210</span>
        <span>Tel: +39-0471-662422</span>
        <span>Fax: +39-0471-673665</span>
        <span>E-mail: info@paulserhof.com</span>

        <div class="spacer sm"></div>

        <h1>Design, Programmierung und CMS</h1>
        <span><strong>Switch</strong></span>
        <span>Hauptstrasse 68</span>
        <span>39018 Terlan</span>
        <span>BZ - Italy</span>
        <span>Mwst.Nr.: 02873000216</span>
        <span>support@superswitch.co</span>

        <div class="spacer sm"></div>

        <h1>Foto Credits</h1>
        <span>Switch, Paulserhof</span>

        <div class="spacer sm"></div>

        <h1>Texting</h1>
        <span>Switch, Elisabeth Kaufmann</span>

      </div>
    </modal>

    <LightBox :images="images" ref="lightbox" :showLightBox="false"></LightBox>

  </div>
</template>

<script>
import Vue from 'vue'
import carousel2 from 'vue-owl-carousel'
import Slick from 'vue-slick'
import LightBox from 'vue-image-lightbox'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
import 'moment/locale/de'
import 'moment/locale/it'
const moment = extendMoment(Moment)
var host = process.env.HOST
var nitro = process.env.NITRO
var auththoken = process.env.AUTHTOKEN
export default {
  name: 'hello',
  data () {
    return {
      loading: true,
      header: '',
      modal: false,
      requestthx: false,
      lang: 'de',
      formlang: {
        date: 'Ankunft und Abreise',
        start: 'Ankunft',
        end: 'Abreise',
        name: 'Name',
        email: 'Emailadresse',
        phone: 'Telefon Nummer',
        message: 'Ihre Nachricht',
        send: 'Anfrage senden'
      },
      drawer: {
        open: false,
        direction: 'rtl'
      },
      rules: {
        date: [
          { required: true, message: 'Bitte geben Sie ein Datum an', trigger: 'blur' }
        ],
        name: [
          { required: true, message: 'questo campo é obbligatorio', trigger: 'blur' }
        ],
        email: [
          { required: true, type: 'email', message: 'Bitte kontrollieren Sie Ihre Emailadresse', trigger: 'blur' }
        ]
      },
      sending: false,
      sentok: false,
      senderror: false,
      slickOptions: {
        slidesToShow: 3,
        infinite: false,
        centerMode: false,
        adaptiveHeight: false,
        variableWidth: false,
        responsive: [
          {
            breakpoint: 367,
            settings: {
              slidesToShow: 1,
              arrows: true
            }
          }
        ],
        centerPadding: '24px',
        prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>'
      },
      request: {
        name: '',
        date: '',
        email: '',
        phone: '',
        message: '',
        arrival: '',
        departure: ''
      },
      welcome: {
        title: 'Willkommen in der Residence Paulserhof',
        intro: '<p>Genießen Sie Ihre wohlverdienten Ferien in der Residence Paulser Hof. Unsere 2019 neu eröffneten Appartements mitten in St. Pauls / Eppan bieten Ihnen ein zweites Zuhause und den perfekten Ausgangspunkt für Ausflüge ins faszinierende Südtirol.</p><p>Kommen Sie in den Genuss der herzlichen Gastfreundschaft der Familie Schwarzer. Lassen Sie sich auf den Charme der wunderbaren Wirtin Elke ein und erfahren Sie was es heißt, ein Lächeln aufs Gesicht gezaubert zu bekommen.</p>'
      },
      rooms: {
        eins: {
          name: 'Appartement Eins',
          desc: '<p>Unsere 2019 gebauten und geräumigen Appartements bestehen alle aus einem Doppelbettzimmer, vollausgestatteter Kochzeile, Kühlschrank mit Gefrierfach, Backrohr, Kaffeemaschine, Wasserkocher, Toaster, Geschirrspüler, Geschirr und Keramikplatte.</p><p>Alle Wohnungen sind mit Terrasse/Balkon, Dusche/WC und Bidet ausgestattet.Unsere Pflegeserie, sowie Handtücher und Bettwäsche stehen Ihnen kostenlos zur Verfügung. Außerdem finden Sie eine eigene Garderobe, einen gemütlichen Esstisch und 2 Fernseher mit Satellitenfernsehen vor. W-LAN in den Appartements frei verfügbar.</p><p>Ebenfalls zu Ihrer Verfügung steht Ihnen pro Appartement ein Parkplatz in unserer Tiefgarage. </p>',
          price: '120,00',
          pricemainseason: '120,00',
          mainimg: '/static/img/eins-living-room-2.jpg',
          pics: [{
            thumb: '/static/img/eins-living-room-couch-1-b.jpg',
            src: '/static/img/eins-living-room-couch-1-b.jpg'
          },
          {
            thumb: '/static/img/eins-living-room-angle-1.jpg',
            src: '/static/img/eins-living-room-angle-1.jpg'
          },
          {
            thumb: '/static/img/eins-terasse-1-b.jpg',
            src: '/static/img/eins-terasse-1-b.jpg'
          },
          {
            thumb: '/static/img/eins-bedroom-window-1-b.jpg',
            src: '/static/img/eins-bedroom-window-1-b.jpg'
          },
          {
            thumb: '/static/img/eins-bedroom-door-1-b.jpg',
            src: '/static/img/eins-bedroom-door-1-b.jpg'
          },
          {
            thumb: '/static/img/eins-bad-2-b.jpg',
            src: '/static/img/eins-bad-2-b.jpg'
          },
          {
            thumb: '/static/img/eins-bad-door-1-b.jpg',
            src: '/static/img/eins-bad-door-1-b.jpg'
          },
          {
            thumb: '/static/img/eins-living-room-window-2-b.jpg',
            src: '/static/img/eins-living-room-window-2-b.jpg'
          }
            // '/static/img/eins-terasse-2.jpg',
            // '/static/img/eins-living-room-3.jpeg',
            // '/static/img/eins-bad.jpg',
            // '/static/img/header-4.jpg'
          ]
        },
        zwei: {
          name: 'Appartement Zwei',
          desc: '<p>Unsere 2019 gebauten und geräumigen Appartements bestehen alle aus einem Doppelbettzimmer, vollausgestatteter Kochzeile, Kühlschrank mit Gefrierfach, Backrohr, Kaffeemaschine, Wasserkocher, Toaster, Geschirrspüler, Geschirr und Keramikplatte.</p><p>Alle Wohnungen sind mit Terrasse/Balkon, Dusche/WC und Bidet ausgestattet.Unsere Pflegeserie, sowie Handtücher und Bettwäsche stehen Ihnen kostenlos zur Verfügung. Außerdem finden Sie eine eigene Garderobe, einen gemütlichen Esstisch und 2 Fernseher mit Satellitenfernsehen vor. W-LAN in den Appartements frei verfügbar.</p><p>Ebenfalls zu Ihrer Verfügung steht Ihnen pro Appartement ein Parkplatz in unserer Tiefgarage. </p>',
          price: '120,00',
          pricemainseason: '120,00',
          mainimg: '/static/img/sofa.jpg',
          pics: [{
            thumb: '/static/img/zwei-living-room-1.jpg',
            src: '/static/img/zwei-living-room-1.jpg'
          },
          {
            thumb: '/static/img/zwei-bedroom-door-1.jpg',
            src: '/static/img/zwei-bedroom-door-1.jpg'
          },
          {
            thumb: '/static/img/zwei-terasse-chair-1.jpg',
            src: '/static/img/zwei-terasse-chair-1.jpg'
          },
          {
            thumb: '/static/img/zwei-bad-door-1.jpg',
            src: '/static/img/zwei-bad-door-1.jpg'
          },
          {
            thumb: '/static/img/zwei-bad-window-1.jpg',
            src: '/static/img/zwei-bad-window-1.jpg'
          },
          {
            thumb: '/static/img/zwei-terasse-angle-1.jpg',
            src: '/static/img/zwei-terasse-angle-1.jpg'
          },
          {
            thumb: '/static/img/zwei-bedroom-main-3.jpg',
            src: '/static/img/zwei-bedroom-main-3.jpg'
          },
          // {
          //   thumb: '/static/img/zwei-entrance-1.jpg',
          //   src: '/static/img/zwei-entrance-1.jpg'
          // },
          {
            thumb: '/static/img/zwei-kitchen-1.jpg',
            src: '/static/img/zwei-kitchen-1.jpg'
          },
          {
            thumb: '/static/img/zwei-living-room-2.jpg',
            src: '/static/img/zwei-living-room-2.jpg'
          }
            // '/static/img/zwei-kitchen-2-2.jpeg',
            // '/static/img/zwei-room-overview-2.jpeg',
            // '/static/img/eins-bad-spiegel.jpg',
            // '/static/img/eins-bad-spiegel.jpg'
          ]
        }
      },
      selectedroom: '',
      slides: {
        eins: [
          '/static/img/eins-bad-spiegel.jpg',
          '/static/img/eins-living-room.jpg',
          '/static/img/eins-terasse.jpg'
        ],
        zwei: [
          '/static/img/zwei-room-detail.jpg',
          '/static/img/zwei-room-overview.jpg',
          '/static/img/zwei-kitchen.jpg'
        ]
      },
      freetime: {
        title: 'Das Beste liegt so nah',
        intro: 'Sport und Freizeit rund um unsere wundershöne Residence Paulserhof in Eppan',
        mainimg: '/static/img/braies-pragser-wildsee-2.jpg',
        sports: [{
          value: {
            img: '/static/img/biking-2.jpg',
            title: 'Biking',
            desc: '<p>Egal ob Singletrail, Bergauf, Bergab oder einfach nur geradeaus - die Vielfalt an <a href="https://www.eppan.com/de/erlebnisse-aktivit%C3%A4ten/biken-wandern-aktiv/biken/biketouren-mountainbike-touren/26-978.html" target="new">Radtouren</a> rund um St. Pauls, Eppan und Umgebung bieten für jeden Radfahrer und Mountainbiker genau das Richtige.</p>'
          }
        },
        {
          value: {
            img: '/static/img/golfen-eppan-2.jpg',
            title: 'Golfen',
            desc: '<p>Nur 5 min entfernt finden Sie den <a href="https://www.golfandcountry.it/the-blue-monster-golfclub-eppan/" target="new">Golfclub Eppan</a>, ein vor kurzem neu gestalteter 9-Loch Golfplatz mit vielen kleinen Seen und meisterlich gepflegtem Green.</p>'
          }
        },
        {
          value: {
            img: '/static/img/wassersport-kaltern-2.jpg',
            title: 'Wassersport',
            desc: '<p>Schwimmen, Stand Up Paddlen, Bootsfahrten, Kiten und <a href="https://www.kalterersee.com/de/freizeit-aktiv/windsurfen/windsurfschule-und-verein/" target="new">Windsurfen</a> - am Kalterer See können Sie sich austoben. Alles in direkter Umgebung Ihres Appartements in Eppan.</p>'
          }
        },
        {
          value: {
            img: '/static/img/hiking-climbing-2.jpg',
            title: 'Hiking & Climbing',
            desc: '<p>Lorem Ipsum</p>'
          }
        }]
      },
      kulinarik: {
        title: 'Gaumenfreuden im Paulserhof',
        intro: 'Klassische Tiroler Hausmannskost auf einem neuen Level, abgerundet durch italienische und internationale Gerichte.',
        mainimg: '/static/img/eins-lagrein-2.jpg',
        dishes: [{
          desc: '',
          img: '/static/img/gulasch-2.jpg'
        },
        {
          desc: '',
          img: '/static/img/knoedel3-2.jpg'
        },
        {
          desc: '',
          img: '/static/img/leber-2.jpg'
        },
        {
          desc: '',
          img: '/static/img/hirten-2.jpg'
        }],
        desc: '<p>Direkt im Paulserhof befindet sich auch unser Restaurant, das mit typischen Tiroler Spezialitäten Ihren Gaumen verwöhnt. Chefkoch Stefan rundet das Angebot gekonnt mit italienischen und internazionalen Gerichten ab.</p><p>Ihre Gastgeberin Elke Schwarzer ist bekannt für Ihre herausragende Kompetenz um die Weinkultur, welche sie mit grosser Leidenschaft und Liebe zum Detail in den Paulserhof einfliesen lässt.</p>'
      },
      images: [
        {
          thumb: '/static/img/eins-living-room-3.jpeg',
          src: '/static/img/eins-living-room-3.jpeg',
          caption: 'caption to display. receive <html> <b>tag</b>'
        },
        {
          thumb: '/static/img/eins-living-room-3.jpeg',
          src: '/static/img/eins-living-room-3.jpeg',
          caption: 'caption to display. receive <html> <b>tag</b>'
        }
      ]
    }
  },
  components: {
    LightBox,
    carousel2,
    Slick
  },
  metaInfo: {
    // Children can override the title.
    // title: 'My Page Title',
    // Result: My Page Title ← My Site
    // If a child changes the title to "My Other Page Title",
    // it will become: My Other Page Title ← My Site
    // titleTemplate: '%s ← My Site',
    // Define meta tags here.
    meta: [
      { name: 'description', content: 'Residence Paulserhof Appartements in Eppan nähe Bozen - Südtirol' }
    ]
  },
  methods: {
    openGallery (index, pics) {
      this.images = pics
      this.$refs.lightbox.showImage(index)
    },
    show (modal, room) {
      // this.selectedroom = room
      // this.modal = true
      this.$modal.show(modal)
    },
    hide (modal) {
      // this.modal = false
      this.$modal.hide(modal)
    },
    getLang () {
      // console.log('lang: ', this.$route.params.lang)
      // console.log('loading 3: ', this.loading)
      this.loading = true
      if (this.$route.params.lang === undefined) {
        this.lang = 'de'
        this.formlang = {
          date: 'Ankunft und Abreise',
          start: 'Ankunft',
          end: 'Abreise',
          name: 'Name',
          email: 'Emailadresse',
          phone: 'Telefon Nummer',
          message: 'Ihre Nachricht',
          send: 'Anfrage senden'
        }
        console.log('default lang')
        this.getContent()
      } else {
        console.log('lang: ', this.$route.params.lang)
        this.lang = this.$route.params.lang
        if (this.$route.params.lang === 'it') {
          this.formlang = {
            date: 'Arrivo e partenza',
            start: 'Arrivo',
            end: 'Partenza',
            name: 'Nome',
            email: 'Indirizzo email',
            phone: 'Telefono',
            message: 'Messaggio personale',
            send: 'Manda richiesta'
          }
        }
        if (this.$route.params.lang === 'en') {
          this.formlang = {
            date: 'Arrival and departure',
            start: 'Arrival',
            end: 'Departure',
            name: 'Name',
            email: 'Email Address',
            phone: 'Phone Number',
            message: 'Personal message',
            send: 'Send request'
          }
        }
        this.getContent()
      }
    },
    sendrequest: function (formName) {
      this.request.arrival = moment(this.request.date[0]).format('DD.MM.YYYY')
      this.request.departure = moment(this.request.date[1]).format('DD.MM.YYYY')
      console.log(this.selectedroom)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.button = '$t("message.lead.thx")'
          // this.sentok = true
          // this.error = true
          this.sending = true
          this.loading = true
          // window.gtag('event', 'conversion', {'send_to': 'AW-951705669/w4s2CN7zu4sBEMXA58UD'})
          this.$http
            .post(host, { appartement: this.selectedroom, request: this.request, lang: this.lang }
            // .post('http://localhost:4000/hi', { chalet: this.chalet, request: this.request }
            ).then((data) => {
              console.log(data)
              this.loading = false
              if (data.status === 200) {
                // this.error = false
                this.sending = false
                this.drawer.open = false
                this.modal = false
                this.requestthx = true
                // window.fbq.push('track', 'Lead')
                // window.gtag('event', 'conversion', {'send_to': 'AW-951705669/w4s2CN7zu4sBEMXA58UD'})
                // window.ga('send', 'event', 'send', 'conversion', 'success')
                this.sentok = true
                this.senderror = false
              } else {
                // this.button = '$t("message.lead.error")'
                this.senderror = true
                // this.sentok = false
                // this.sending = false
              }
            }, (error) => {
              console.log(error)
              this.loading = false
              this.senderror = true
              this.sending = false
            })
          this.$http
            .post(nitro, { appartement: this.selectedroom.name, request: this.request, lang: this.lang },
              {
                headers: {
                  'Authorization': 'Bearer ' + auththoken
                }
              }
            ).then((data) => {
              console.log(data)
            }, (error) => {
              console.log(error)
            })
        }
      })
    },
    getContent () {
      // console.log('loading 4: ', this.loading)
      const html = document.documentElement // returns the html tag
      html.setAttribute('lang', this.lang)
      this.$http
        .post('https://content.ombrelleria.com/api/singletons/get/residencepaulserhof?lang=' + this.lang
        ).then((data) => {
          // console.log('data loaded: ', data.body)
          this.welcome = data.body.welcome
          this.rooms.eins.name = data.body.appeins.name
          this.rooms.eins.desc = data.body.appeins.desc
          this.rooms.eins.price = data.body.appeins.price
          this.rooms.eins.pricemainseason = data.body.appeins.pricemainseason
          this.rooms.zwei.name = data.body.appzwei.name
          this.rooms.zwei.desc = data.body.appzwei.desc
          this.rooms.zwei.price = data.body.appzwei.price
          this.rooms.zwei.pricemainseason = data.body.appzwei.pricemainseason
          this.freetime.title = data.body.freetime.title
          this.freetime.intro = data.body.freetime.intro
          this.freetime.sports = data.body.sports
          this.kulinarik.title = data.body.kulinarik.title
          this.kulinarik.intro = data.body.kulinarik.intro
          this.kulinarik.desc = data.body.kulinarik.desc
          this.loading = false
          // console.log('loading 5: ', this.loading)
        }, (error) => {
          console.log('error: ', error)
          // this.fallback()
        })
    },
    fallback () {
      this.$http
        .get('https://residence-paulserhof.firebaseio.com/content.json?orderBy="_modified"&limitToLast=1'
        ).then((data) => {
          // console.log('fallback: ', data.body)
          var fireid = Object.keys(data.body)[0]
          console.log(data.body[fireid].args[1])
          const contenfields = ['welcome']
          // this.content = data.body[fireid].args[1]
          const values = Object.entries(data.body[fireid].args[1])
          if (this.lang.length === 0 || this.$route.params.lang === 'en') {
          } else {
            values.forEach((field, index) => {
              // console.log(field[0], field[1])
              if (contenfields.includes(field[0])) {
                var fiel = field[0] + '_' + this.lang
                var entries = Object.keys(field[1])
                // var values2 = Object.values(field[1])
                // console.log('fiel: ', fiel, 'entry: ', entries, values2)
                // Vue.set(this, field[0], data.body[fireid].args[1][fiel])
                entries.forEach((entry, index) => {
                  console.log('field: ', field[0], data.body[fireid].args[1][fiel][entry], 'entry: ', entry)
                  Vue.set(this, field[0].entry, data.body[fireid].args[1][fiel][entry])
                })
              }
            })
          }
          this.loading = false
        }, (error) => {
          console.log(error)
        })
    }
  },
  watch: {
    $route (to, from) {
      console.log('cahnge')
      this.getLang()
    }
  },
  beforeMount () {
    this.getLang()
    // console.log('loading 1: ', this.loading)
  },
  mounted () {
    // console.log('loading final: ', this.loading)
    // this.loading = false
    this.selectedroom = this.rooms.eins
    // this.getLang()
    // this.getContent()
    // setTimeout(() => {
    //   this.loading = false
    // }, 2000)
  },
  created () {
    this.loading = true
    // console.log('loading 2: ', this.loading)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue